import React from 'react'
import close from '../../assets/images/close.svg'


const AddMenu = ({ showAddInput, newMenuName, setNewMenuName, error, handleSaveMenu, setShowAddInput, refrence, setError, styles }) => {
    return (
        <>
            {showAddInput && (
                <>
                    <div className="popup-overlay">
                    </div>
                    <div className="popup-box add-new-user" ref={refrence}>
                        <div className="popupTop popupTopClose closePlan previewClose">
                            <img src={close} onClick={() => setShowAddInput(false)} alt="Icon" />
                        </div>
                        <div className='popupModalTitle'>Add Menu</div>
                        <div className={styles.addMenuContent}>
                            <div>
                                <input
                                    type="text"
                                    value={newMenuName}
                                    onChange={(e) => {setNewMenuName(e.target.value); setError("")}}
                                    placeholder="Enter menu name"
                                    className={styles.menuAddInput}
                                />

                                {error && (
                                    <p className='error-message'>{error}</p>
                                )}
                            </div>

                            <button
                                className={styles.addBtn}
                                onClick={handleSaveMenu}
                            >
                                Save
                            </button>
                        </div>
                    </div>
                </>
            )}
        </>
    )
}

export default AddMenu